import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CheckoutBinance = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/carrinho');
  }, [navigate]);

  return null;
};

export default CheckoutBinance;
